import React from 'react';
import BlurFade from '../primitives/BlurFade';
import Pill from '../ui/Pill';
import { Section } from '../layout/Section';
import { Container } from '../layout/Container';
import { Eyebrow, Headline, Body } from '../layout/typography';
import { useLang } from '../../LangContext';
import { mediaAlt } from '../../lib/mediaSeo';

/**
 * FinalCTABlock — Act VIII (Reassurance). Multi-path final ask: form/phone/whatsapp.
 */
export default function FinalCTABlock({
  tone = 'cream-sand', rhythm = 'grand', eyebrow, headline, sub, bgImage, ctas = [],
}) {
  const { lang, overlay } = useLang();
  const primary = ctas.find((c) => c.kind === 'primary');
  const phone = ctas.find((c) => c.kind === 'phone');
  const whatsapp = ctas.find((c) => c.kind === 'whatsapp');
  return (
    <Section data-testid="final-cta" tone={tone} rhythm={rhythm}>
      {bgImage && (
        <>
          <div className="absolute inset-0 opacity-50">
            <img src={bgImage} alt={mediaAlt(overlay, bgImage, lang, headline || eyebrow || '')} className="w-full h-full object-cover" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-[#FAF8F2]/30 via-[#FAF8F2]/60 to-[#FAF8F2]/90" />
        </>
      )}
      <Container variant="narrow" className="relative z-10 text-center">
        <BlurFade><Eyebrow className="mb-9">{eyebrow}</Eyebrow></BlurFade>
        <BlurFade delay={0.05}><Headline size="hero">{headline}</Headline></BlurFade>
        <BlurFade delay={0.15}><Body size="lg" className="mt-8 max-w-md mx-auto">{sub}</Body></BlurFade>
        <BlurFade delay={0.25} className="mt-12 flex flex-col sm:flex-row gap-3 justify-center">
          {primary && (
            <Pill variant="leaf" href={primary.href} testId={primary.testId} source={primary.source}>
              {primary.label}
            </Pill>
          )}
          {phone && (
            <Pill variant="outline" icon="phone" iconLeft href={phone.href} testId={phone.testId} magnetStrength={0.22}>
              {phone.label}
            </Pill>
          )}
          {whatsapp && (
            <Pill variant="outline" icon="whatsapp" iconLeft href={whatsapp.href} testId={whatsapp.testId}
              target="_blank" rel="noreferrer" magnetStrength={0.22}>
              {whatsapp.label}
            </Pill>
          )}
        </BlurFade>
      </Container>
    </Section>
  );
}
